import React from "react";

import Icon from "../../../../components/Icon";

export const FilterChips = ({ chips, onRemove, onClear }) => {
    if (chips.length === 0) return null;

    return (
        <div className="finance-filter-chips">
            {chips.map(chip => (
                <span className="filter-chip" key={chip.key}>
                    <span>{chip.label}</span>
                    <button type="button" onClick={() => onRemove(chip.key)} aria-label={`Remover filtro ${chip.label}`}>
                        <Icon name="close" size={14} />
                    </button>
                </span>
            ))}
            <button type="button" className="filter-chips-clear" onClick={onClear}>
                <Icon name="delete" size={15} />
                Limpar filtros
            </button>
        </div>
    );
};

export default FilterChips;
